import { BenefitDTOBenefitEnum, BenefitTemplateItemDTO } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';
import { useMemo } from 'react';
import { BenefitRef } from './BenefitsCell';

export const COMMON_BENEFIT_EXCLUDES = [
  BenefitDTOBenefitEnum.Gifts,
  BenefitDTOBenefitEnum.News,
  BenefitDTOBenefitEnum.DiscountCode,
  BenefitDTOBenefitEnum.Fitness,
  BenefitDTOBenefitEnum.CreditCard,
  BenefitDTOBenefitEnum.Wellpass,
] as const;

export function useExcludedBenefits(
  explicitlyExclude: readonly BenefitDTOBenefitEnum[] = COMMON_BENEFIT_EXCLUDES,
  templateItems?: BenefitTemplateItemDTO[],
): {
  excludedRefs: BenefitRef[];
  excludedBenefits: BenefitDTOBenefitEnum[];
} {
  const { tenant } = useTenant();

  return useMemo(() => {
    const commonBenefitRefExcludes: { benefit: BenefitDTOBenefitEnum }[] = explicitlyExclude.map(benefit => ({ benefit }));
    const fromTemplate: BenefitRef[] =
      templateItems?.map(val => ({ benefit: val.benefit, customBenefitId: val.customBenefitOptions?.customBenefitId })) ?? [];
    const fromTenant: BenefitRef[] = tenant?.flexBenefits?.map(benefit => ({ benefit })) ?? [];

    const excludedRefs = [...commonBenefitRefExcludes, ...fromTenant, ...fromTemplate];
    const excludedBenefits = excludedRefs.map(val => val.benefit);

    return { excludedRefs, excludedBenefits };
  }, [explicitlyExclude, templateItems, tenant?.flexBenefits]);
}
